import { useMemo } from 'react';
import { useGetApproversQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from '../constants/approvalTypeIds';
import { useAppHubUsers } from './useAppHubUsers';
import { captureException } from '../utils/sentryUtils';
import { actorToApprovalUser } from '../utils/chirpApprovalAdapters';
export const useApprovers = (approvalType, approvalAction) => {
  const {
    data: chirpData,
    loading: chirpLoading,
    error: chirpError
  } = useGetApproversQuery({
    variables: {
      approvalType,
      approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
      approvalAction
    },
    onError: error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovers-chirp',
          approvalType,
          approvalAction
        }
      });
    }
  });
  const actorUserIds = useMemo(() => {
    if (!(chirpData !== null && chirpData !== void 0 && chirpData.approvers)) return [];
    return chirpData.approvers.map(actor => Number(actor.id));
  }, [chirpData]);
  const {
    usersRecord,
    loading: usersLoading,
    error: usersError
  } = useAppHubUsers(actorUserIds);
  const approvers = useMemo(() => {
    if (!(chirpData !== null && chirpData !== void 0 && chirpData.approvers) || usersLoading) return [];
    return chirpData.approvers.map(actor => actorToApprovalUser(actor.id, usersRecord));
  }, [chirpData, usersRecord, usersLoading]);
  return {
    approvers,
    isLoading: chirpLoading || usersLoading,
    isError: Boolean(chirpError) || Boolean(usersError)
  };
};